import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-scala',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Scala icon</title><path d="M4.589 24c4.537 0 13.81-1.516 14.821-3v-5.729c-.957 1.408-10.284 2.912-14.821 2.912V24zM4.589 16.365c4.537 0 13.81-1.516 14.821-3V7.636c-.957 1.408-10.284 2.912-14.821 2.912v5.817zM4.589 8.729c4.537 0 13.81-1.516 14.821-3V0C18.453 1.408 9.126 2.912 4.589 2.912v5.817z"/></svg>`,
    styles: []
})
export class SimpleIconsScalaComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#DC322F';
    @Input() className: string = 'simple-icons-scala'
    constructor() {}
    ngOnInit(): void {}
}
